import { MapPin } from 'lucide-react';
import { cn } from '@eombor/ui';
import { t } from '../i18n/index.js';

/**
 * Koordinata — XARITADA ochiladigan havola.
 *
 * Raqamning o'zi ("38.86000, 65.79000") deyarli hech kimga hech narsa
 * aytmaydi: rahbar uni ko'rib, qayerdaligini bilmaydi va qo'lda nusxa
 * ko'chirib xaritaga qidirishi kerak bo'lardi. Havola bo'lgach, u bir
 * bosishda ochiladi — telefonda esa xarita ilovasining o'zi ochiladi.
 *
 * Raqam ham QOLADI: ichki tarmoqda internet bo'lmasa havola ochilmaydi va
 * shunda koordinata yagona ma'lumot bo'lib qoladi. Faqat belgichaga
 * aylantirilsa, aynan o'sha holatda ekranda hech narsa qolmasdi.
 */

/**
 * Xarita xizmati — bitta joyda.
 *
 * Google Maps tanlandi: havola brauzerda ham ochiladi, telefonda esa
 * o'rnatilgan xarita ilovasini o'zi chaqiradi. Yandex ga o'tish kerak
 * bo'lsa, o'zgaradigan joy shu bitta qator.
 */
const mapUrl = (lat: number, lng: number): string =>
  `https://www.google.com/maps?q=${lat},${lng}`;

const format = (value: number): string => value.toFixed(5);

export interface GeoLinkProps {
  gps: { lat: number; lng: number };
  className?: string;
  /** Ko'ruvchining qora foni uchun — oq matn. */
  tone?: 'default' | 'onDark';
}

export const GeoLink = ({ gps, className, tone = 'default' }: GeoLinkProps) => (
  <a
    href={mapUrl(gps.lat, gps.lng)}
    target="_blank"
    rel="noreferrer noopener"
    title={t('handover.mapOpen')}
    className={cn(
      'tabular inline-flex items-center gap-1.5 underline decoration-dotted underline-offset-2',
      'transition-colors duration-[var(--motion-fast)]',
      tone === 'onDark' ? 'text-white/80 hover:text-white' : 'text-text hover:text-accent',
      className,
    )}
  >
    <MapPin size={14} aria-hidden />
    {format(gps.lat)}, {format(gps.lng)}
  </a>
);
